import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue';
import VueCookie from 'vue-cookie';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import { sync } from 'vuex-router-sync';
import Autocomplete from 'v-autocomplete';
import VeeValidate from 'vee-validate';
import VueClipboards from 'vue-clipboards';
import vueDropzone from 'vue2-dropzone';

import VueWait from 'vue-wait';
import { HollowDotsSpinner } from 'epic-spinners';

import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import 'flag-icon-css/css/flag-icon.min.css';

import App from './App.vue'
import store from './store/index';
import router from './router/index';
import './router/Interceptor';
import i18n from './i18n.bootstrap';
import './filters/filter';

import '@/filters/filters';

import toastr from 'toastr';
import 'toastr/build/toastr.css';

import 'vue-snotify/styles/material.css';
import 'v-autocomplete/dist/v-autocomplete.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue2-dropzone/dist/vue2Dropzone.css';

import '../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

import 'vue-multiselect-listbox/dist/vue-multi-select-listbox.css';

import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import InfiniteLoading from "vue-infinite-loading";
import vMultiselectListbox from "vue-multiselect-listbox";
LicenseManager.setLicenseKey('Optimal_Systems_GmbH__Devs_UmlimitedOEM_31_May_2019__MTU1OTI1NzIwMDAwMA==f9a0c9ce183f739058295d6a64a30c84');

toastr.options.preventDuplicates = true;
toastr.options.positionClass = 'toast-bottom-right';

Vue.config.productionTip = false

sync(store, router); 

Vue.component('icon', Icon);
Vue.component('vue-dropzone', vueDropzone);
Vue.component('hollow-dots-spinner', HollowDotsSpinner);
Vue.component('v-multiselect-listbox', vMultiselectListbox)

Vue.use(VueCookie);
Vue.use(BootstrapVue);
Vue.use(VueClipboards);
Vue.use(Autocomplete);
Vue.use(VueWait);

Vue.use(Snotify, {
  toast: {
    timeout: 5000,
    position: SnotifyPosition.centerTop
  }
});

Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors'
});

Vue.use(InfiniteLoading, { /* options */ });

new Vue({
    router,
    store,
    i18n,
    wait: new VueWait(),
    render: h => h(App)
}).$mount('#app')
